module.exports = __webpack_public_path__ + "static/media/pizza.aa3a12e6.jpg";